<form [formGroup]="manufactureForm" class="rx-intuitive-implants-form">
	<rx-favorite-selector
		class="rx-intuitive-implants-form__field"
		[id]="'intuitive-scan-body-manufacturer'"
		[label]="'ToothEditor.ScanBodyManufacturer' | translate"
		[isRequired]="shouldValidateForSend"
		[isCancellable]="shouldValidateForSend === false && isProcedureFlow"
		[formControl]="scanBodyManufacturerControl"
		[isReadOnly]="false"
		[options]="scanBodyManufacturerOptions"
		[favoriteName]="favoriteScanBody"
		name="scanBodyManufacturerControl"
		[enableSimpleMode]="isFavoritesHidden"
	></rx-favorite-selector>
	<rx-favorite-selector
		class="rx-intuitive-implants-form__field"
		[id]="'intuitive-implant-manufacturer'"
		[label]="'ToothEditor.ImplantManufacturer' | translate"
		[isReadOnly]="false"
		[isRequired]="shouldValidateForSend"
		[isCancellable]="shouldValidateForSend === false && isProcedureFlow"
		[formControl]="implantManufacturerControl"
		[options]="implantManufacturerOptions"
		[isDisabled]="!implantManufacturerOptions?.length"
		[favoriteName]="favoriteImplant"
		name="implantManufacturerControl"
		[enableSimpleMode]="isFavoritesHidden"
	></rx-favorite-selector>
	<rx-select
		class="rx-intuitive-implants-form__field"
		[id]="'intuitive-implant-type-scan-body'"
		[label]="'ToothEditor.ImplantTypeScanBody' | translate"
		[isDisabled]="!implantTypeScanBodyOptions?.length"
		[isRequired]="shouldValidateForSend"
		[isCancellable]="shouldValidateForSend === false && isProcedureFlow"
		[formControl]="implantTypeScanBodyControl"
		[options]="implantTypeScanBodyOptions"
		[dropdownPositions]="'right'"
		[panelClass]="'implant-type-scan-body-panel'"
	></rx-select>
</form>
